import React, { useCallback, useRef, useState } from "react";
import { FaCloudUploadAlt } from "react-icons/fa";
import "./mediaLibrary.css";

export default function MediaUploadZone({ onUpload, disabled, busy }) {
  const inputRef = useRef(null);
  const [dragOver, setDragOver] = useState(false);

  const pickFiles = useCallback(() => {
    if (disabled || busy) return;
    inputRef.current?.click();
  }, [disabled, busy]);

  const handleFiles = useCallback(
    async (fileList) => {
      if (!fileList?.length || disabled || busy) return;
      const images = Array.from(fileList).filter((f) => f.type.startsWith("image/"));
      if (!images.length) return;
      await onUpload?.(images);
    },
    [disabled, busy, onUpload]
  );

  const onInputChange = (e) => {
    handleFiles(e.target.files);
    e.target.value = "";
  };

  const onDrop = (e) => {
    e.preventDefault();
    setDragOver(false);
    handleFiles(e.dataTransfer.files);
  };

  return (
    <div
      className={`mediaUploadZone ${dragOver ? "mediaUploadZoneActive" : ""} ${disabled || busy ? "mediaUploadZoneDisabled" : ""}`}
      onDragEnter={(e) => {
        e.preventDefault();
        if (!disabled && !busy) setDragOver(true);
      }}
      onDragLeave={(e) => {
        if (!e.currentTarget.contains(e.relatedTarget)) setDragOver(false);
      }}
      onDragOver={(e) => e.preventDefault()}
      onDrop={onDrop}
    >
      <input
        ref={inputRef}
        type="file"
        accept="image/*"
        multiple
        className="mediaUploadInput"
        onChange={onInputChange}
        disabled={disabled || busy}
        aria-hidden
      />
      <button
        type="button"
        className="mediaUploadZoneInner"
        onClick={pickFiles}
        disabled={disabled || busy}
        aria-label="Upload images"
      >
        <span className="mediaUploadIcon" aria-hidden="true">
          <FaCloudUploadAlt />
        </span>
        <span className="mediaUploadTitle">{busy ? "Uploading…" : "Drop images here or click to upload"}</span>
        <span className="mediaUploadHint">PNG, JPG, WebP, GIF — multiple files allowed</span>
      </button>
    </div>
  );
}
